import { render, staticRenderFns } from "./CollectiveListItem.vue?vue&type=template&id=6a77d98d&scoped=true"
import script from "./CollectiveListItem.vue?vue&type=script&lang=js"
export * from "./CollectiveListItem.vue?vue&type=script&lang=js"
import style0 from "./CollectiveListItem.vue?vue&type=style&index=0&id=6a77d98d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a77d98d",
  null
  
)

export default component.exports